export default __webpack_public_path__ + "static/media/voltascore.400110d3.svg";